import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { register, saveClaim } from '../../store/features/userSlice';
import { fetchClientByActivationCode } from '../../store/features/clientSlice';
import styles from './login.module.scss';
import { Button } from '@mui/material';
import { useCookies } from 'react-cookie';
import withNotify from "../../component/_HighOrder/withNotify";
import ReCAPTCHA from "react-google-recaptcha";
import Config from '../../config';

const Registration = (props) => {
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(['.AspNetCore.Antiforgery.hwgKeCFeRls']);
    const [validations, setValidations] = useState(null);
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const [data, setData] = useState({
        email: '',
        confirmEmail: '',
        userName: '',
        password: '',
        confirmPassword: '',
        cgCode: '',
        birthDate: ''
    });

    const validatePassword = (password) => {
        const minLength = password.length >= 6;
        const hasUppercase = /[A-Z]/.test(password);
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
        const hasNumber = /\d/.test(password);
        
        return minLength && hasUppercase && hasSpecialChar && hasNumber;
    };

    const onRegister = (event) => {
        event.preventDefault();

        if (data.email && !data.confirmEmail)
            return props.notify.error('Confirm Email is Required!');
        if (!data.userName)
            return props.notify.error('Username is Required!');
        if (!data.cgCode)
            return props.notify.error('Activation Code is Required!');
        if (!data.birthDate)
            return props.notify.error('Birth Date is Required!');
        if (!data.password)
            return props.notify.error('Password is Required!');
        if (!validatePassword(data.password))
            return props.notify.error('Password must be at least 6 characters and contain at least 1 uppercase letter, 1 number, and 1 special character!');
        if (!data.confirmPassword)
            return props.notify.error('Confirm Password is Required!');
        if (data.password !== data.confirmPassword)
            return props.notify.error('Passwords do not match!');
        if (!recaptchaValue)
            return props.notify.error('Please complete the reCAPTCHA!');

        dispatch(fetchClientByActivationCode({
            activationCode: data.cgCode,
            dateOfBirth: data.birthDate,
            callback: (response) => {
                if(!response)
                    return props.notify.error('Invalid Activation Code!');
                if (response)
                    return registerUser(response);
            },
            catch: (error) => {
                console.log('Error fetching Client with this Activation Code:', error);
                props.notify.error('Error fetching Client with this Activation Code!');
            }
        }));
    };

    const registerUser = (validationResponse) => {
        console.log('validationResponse', validationResponse);
        dispatch(register({
            data,
            callback: (response) => {
                if (validationResponse.scConsumerId !== null) {
                    addClaim(response.UserId, validationResponse.scConsumerId);
                }
                if (validationResponse.authorizations.length) {
                    // for (const authorization of validationResponse.authorizations) {
                    for (let index = 0, len = validationResponse.authorizations.length; index < len; index++) {
                        if (validationResponse.authorization[index].authorizedIdentity.scConsumerId !== null) {
                            addClaim(response.UserId, validationResponse.authorization[index].authorizedIdentity.scConsumerId);
                        }
                    }
                }
            },
            validate: (validations) => {
                setValidations(JSON.parse(validations));
            },
            catch: (error) => { console.log('registration failed', error) }
        }));
    }

    const addClaim = (userId, forUser) => {
        //let antiForgeryToken = Cookies.get('.AspNetCore.Antiforgery.hwgKeCFeRls');
        let sdf = cookies['idsrv.session'];
        console.log('saving claim userId', userId);
        console.log('saving claim forUser', forUser);
        dispatch(saveClaim({
            userId,
            code: forUser,
            // code: data.cgCode,
            antiForgeryToken: sdf,
            callback: (response) => {
                props.setUserRegistered(true);
                props.setRegister(false);
            },
            catch: (error) => {
                props.notify.error('Registration failed');
            }
        }));
    }

    const getBack = (event) => {
        event.preventDefault();
        props.setRegister(false);
    }

    const onRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };

    return (
        <form onSubmit={(event) => onRegister(event)}>
            <div className={styles.practitionerDiv}>
                <button className={styles.filterBtn} onClick={(event) => getBack(event)}>Back</button>

                <h2>Registration</h2>
                {
                    validations &&
                    <div className={styles.loginDiv}>
                        <ul className={styles.validationList}>
                            {validations.map((item, index) => <li key={index} className={styles.validationItem}>{item}</li>)}
                        </ul>
                    </div>
                }
                <div className={styles.loginDiv}>
                    <label htmlFor="email" className={styles.loginLabel}>Email</label>
                    <input 
                        id="email"
                        type="text" 
                        className={styles.loginInput} 
                        value={data.email} 
                        onChange={(event) => setData({ ...data, email: event.target.value })} 
                    />
                </div>
                {
                    data.email &&
                    <div className={styles.loginDiv}>
                        <label htmlFor="confirmEmail" className={styles.loginLabel}>Confirm Email</label>
                        <input 
                            id="confirmEmail"
                            type="text" 
                            className={styles.loginInput} 
                            value={data.confirmEmail} 
                            onChange={(event) => setData({ ...data, confirmEmail: event.target.value })} 
                        />
                    </div>
                }
                <div className={styles.loginDiv}>
                    <label htmlFor="userName" className={styles.loginLabel}>Username</label>
                    <input 
                        id="userName"
                        type="text" 
                        className={styles.loginInput} 
                        value={data.userName} 
                        onChange={(event) => setData({ ...data, userName: event.target.value })}
                    />
                </div>
                <div className={styles.loginDiv}>
                    <label htmlFor="cgCode" className={styles.loginLabel}>Activation Code</label>
                    <input 
                        id="cgCode"
                        type="text" 
                        className={styles.loginInput} 
                        value={data.cgCode} 
                        onChange={(event) => setData({ ...data, cgCode: event.target.value })}
                    />
                </div>
                <div className={styles.loginDiv}>
                    <label htmlFor="birthDate" className={styles.loginLabel}>Birth Date</label>
                    <input 
                        id="birthDate"
                        type="date" 
                        className={styles.loginInput} 
                        value={data.birthDate} 
                        onChange={(event) => setData({ ...data, birthDate: event.target.value })}
                    />
                </div>
                <div className={styles.loginDiv}>
                    <label htmlFor="password" className={styles.loginLabel}>Password</label>
                    <input 
                        id="password"
                        type="password" 
                        className={styles.loginInput} 
                        value={data.password} 
                        onChange={(event) => setData({ ...data, password: event.target.value })}
                    />
                </div>
                <div className={styles.loginDiv}>
                    <label htmlFor="confirmPassword" className={styles.loginLabel}>Confirm Password</label>
                    <input 
                        id="confirmPassword"
                        type="password" 
                        className={styles.loginInput} 
                        value={data.confirmPassword} 
                        onChange={(event) => setData({ ...data, confirmPassword: event.target.value })}
                    />
                </div>
                <div className={styles.loginDiv}>
                    <ReCAPTCHA
                        sitekey={Config.recaptchaSiteKey}
                        onChange={onRecaptchaChange}
                    />
                </div>
                <Button type='submit' variant="contained" onClick={(event) => onRegister(event)}>
                    Register
                </Button>
            </div>
        </form>
    );
};

export default withNotify(Registration);
